export enum SystemAnnouncementEnum {
  systemAnnouncements = 'SystemAnnouncement/SystemAnnouncements', // 取得系統公告資料清單
  systemAnnouncement = 'SystemAnnouncement/SystemAnnouncement', // 取得系統公告資料
  termsAgreement = 'SystemAnnouncement/TermsAgreement', // 取得使用者條款同意狀態
  updateTermsAgreement = 'SystemAnnouncement/UpdateTermsAgreement' // 更新使用者條款同意狀態
}
